import { markSigningOut } from './signOutState';
import { userManager } from './userManager';

// In E2E builds the OIDC dance never runs — the fixture installs a fake session
// in localStorage, so signing out means clearing that seam and reloading.
const isE2E = import.meta.env.VITE_E2E === 'true';

export async function logout(): Promise<void> {
  markSigningOut();

  if (isE2E) {
    localStorage.removeItem('e2e_auth_data');
    window.location.assign('/');
    return;
  }

  await userManager.signoutRedirect();
}
